import { QueryBuilder, RuleType } from "react-querybuilder"
import { QueryBuilderMaterial } from "@react-querybuilder/material"
import "react-querybuilder/dist/query-builder.css"
import { RuleGroupType, formatQuery } from "react-querybuilder"
import { Box, Button, Paper, Typography } from "@mui/material"
import { useMemo, useState } from "react"
import { useNavigate } from "react-router-dom"
import { getValueLabels } from "./fields"
import { useSearchFields } from "../../hooks/ricerca"
import { useTranslation } from "react-i18next"

type RicercaQueryProps = {
  query: RuleGroupType
  setQuery: (query: RuleGroupType) => void
}

export default function RicercaQuery({ query, setQuery }: RicercaQueryProps) {
  const [localQuery, setLocalQuery] = useState<RuleGroupType>(query)

  const { data: fields } = useSearchFields()
  const { t } = useTranslation()

  const natualLangQuery = useMemo(() => {
    if (!localQuery || !fields) return ""
    return formatQuery(localQuery, {
      format: "natural_language",
      fields,
      valueProcessor: (rule: RuleType) => getValueLabels(rule, fields),
    })
  }, [localQuery, fields])

  const isEmptyQuery = useMemo(() => {
    return !localQuery || localQuery.rules.length === 0
  }, [localQuery])

  const navigate = useNavigate()

  return (
    <div>
      <Paper sx={{ px: 2, py: 1, mb: 2 }}>
        <Typography variant="caption" sx={{ mb: 0 }}>
          {t("general.query")}
        </Typography>
        {!isEmptyQuery && <Typography>{natualLangQuery}</Typography>}
        {isEmptyQuery && <Typography><i>{t("general.nessuna_query")}</i></Typography>}
      </Paper>
      <Box sx={{ mb: 2 }}>
        <QueryBuilderMaterial>
          {fields && <QueryBuilder fields={fields} query={localQuery} onQueryChange={setLocalQuery} />}
        </QueryBuilderMaterial>
      </Box>
      <Button
        sx={{ mb: 2 }}
        variant="contained"
        
        onClick={() => {
          if (!localQuery) return
          setQuery(localQuery)
          navigate({
            pathname: "/it/ricerca/risultati",
            search: `?query=${JSON.stringify(localQuery)}`,
          })
        }}
      >
        {t("general.cerca")}
      </Button>
    </div>
  )
}
